'use strict';


module.exports = function () {
    setTimeout(function () {
        $('.new-loader-wrapper').fadeOut().addClass('withoutBG');
    }, 1000);
};
